module.exports = __webpack_public_path__ + "fonts/BPG-Besarion-III-D-Caps.d9a51f6c.woff2";